import { useState } from 'react'

import { Button, Card, GlossaryText, Icon, Toast, ToastHost } from '../../ui'
import { ReportPreviewDialog } from './ReportPreviewDialog'
import { SendReportDialog } from './SendReportDialog'
import { useW5Live } from './live'
import styles from './AnalysisPage.module.css'

function reportLead(report: ReturnType<typeof useW5Live>['report']) {
  const highlights = new Set([report.kpis[2]?.delta, report.kpis[0]?.delta])
  const terms = [...highlights].filter(Boolean).join('|').replaceAll('+', '\\+')
  return report.lead.split(new RegExp(`(${terms})`, 'g')).map((part, index) => (
    highlights.has(part) ? <b key={`${part}-${index}`}>{part}</b> : <GlossaryText key={`${part}-${index}`} text={part} />
  ))
}

export function WeeklyReportCards() {
  const { report, taskRows } = useW5Live()
  const [previewOpen, setPreviewOpen] = useState(false)
  const [sendOpen, setSendOpen] = useState(false)
  const [toast, setToast] = useState<string | null>(null)
  return (
    <div className={`${styles.reportGrid} ${styles.section}`}>
      <Card className={styles.reportCard} data-scope="ai-weekly-report">
        <div className={styles.avatar}><Icon name="sparkle" size={26} strokeWidth={1.8} /></div>
        <div className={styles.reportBody}>
          <p className={styles.reportTitle}>
            AI 本周汇报{' '}
            <span className={styles.reportPeriod}><i />{report.range}</span>
            <span className={styles.grade}>评级 {report.grade}</span>
          </p>
          <p className={styles.reportLead}>{reportLead(report)}</p>
          <div className={styles.reportStats}>
            {report.stats.map((stat) => (
              <div key={stat.label}>
                <p className={`${styles.statValue} ${stat.tone === 'you' ? styles.statYou : stat.label.includes('AI') ? styles.statAi : ''}`}>{stat.value}</p>
                <p className={styles.statLabel}>{stat.label}</p>
              </div>
            ))}
          </div>
          <div className={styles.kpiMiniGrid}>
            {report.kpis.map((kpi) => (
              <div key={kpi.label}>
                <p className={styles.kpiLabel}><GlossaryText text={kpi.label} /></p>
                <p className={styles.kpiValue}>{kpi.value}</p>
                <p className={`${styles.kpiDelta} ${kpi.good ? styles.kpiGood : styles.kpiBad}`}>{kpi.delta}</p>
              </div>
            ))}
          </div>
        </div>
      </Card>
      <Card className={styles.outputCard} data-scope="report-output">
        <div className={styles.outputHead}>
          <span className={styles.outputIcon}><Icon name="file" size={22} /></span>
          <div>
            <b>{report.title} · {report.issue}</b>
            <span>{report.range} · 生成于 {report.made} · AI广告引擎</span>
          </div>
        </div>
        <div className={styles.outputButtons}>
          <Button onClick={() => setPreviewOpen(true)}><Icon name="download" size={15} />导出 PDF</Button>
          <Button variant="ghost" onClick={() => setSendOpen(true)}><Icon name="send" size={15} />发送给客户</Button>
        </div>
        <div className={styles.outputLedger}>
          <span>{report.reportExports.length > 0 ? `最近导出 第 ${report.reportExports.at(-1)?.seq} 次 · ${report.reportExports.at(-1)?.at}` : '最近导出 尚无'}</span>
          <span>上次发送 {report.reportSentAt}</span>
          <span>本期已发送 {report.reportSendCount} 次</span>
        </div>
        <div className={styles.keyValue}><span>定时</span><b>{report.schedule}</b></div>
        <div>
          <p className={styles.historyTitle}>历史周报</p>
          <div className={styles.historyList}>
            {report.history.map((item) => (
              <div className={styles.historyItem} key={item.issue}>
                <Icon name="file" size={15} />
                <span>{item.range}</span>
                <span className={styles.historyGrade}>{item.issue} · {item.grade}</span>
              </div>
            ))}
          </div>
        </div>
      </Card>
      {previewOpen ? <ReportPreviewDialog open report={report} taskRows={taskRows} onClose={() => setPreviewOpen(false)} onDone={(item) => setToast(`已生成${report.issue}报告预览（${report.range}）· 第 ${item.seq} 次导出 · ${item.at}`)} /> : null}
      {sendOpen ? <SendReportDialog open report={report} onClose={() => setSendOpen(false)} onDone={setToast} /> : null}
      {toast ? <ToastHost><Toast onDismiss={() => setToast(null)}>{toast}</Toast></ToastHost> : null}
    </div>
  )
}
